import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	id: string
}

export async function occupationCategoryDeleteApi(
	payload: RequestDataShape,
	token: string,
) {
	const endpoint = "/occupationCategory/delete/v1"
	const requester = new ApiRequester<RequestDataShape, void>(endpoint)
	await requester.sendRequest(payload, token)
}
